export default __webpack_public_path__ + "static/media/27da407cd76c1fb74defda298a9770ed.12f6ce54.png";